import BaseIndexedDB from '../IndexedDB/IndexedDB.js';
import BaseSchemaUpgrade from '../IndexedDB/SchemaUpgrade.js';

export const IndexedDB = BaseIndexedDB;
export type SchemaUpgrade = BaseSchemaUpgrade;